// extracted by mini-css-extract-plugin
export var aboveInput = "_n5-0";
export var actionButton = "_n5-5";
export var actionButtonContainer = "_n5-1";
export var actionIcon = "_n5-6";
export var aiInfoContainer = "_n5-2";
export var attachmentWrapper = "_n5-7";
export var bold = "_n5-3";
export var checkIcon = "_n5-8";
export var clickingRecipientBar = "_n5-11";
export var commentThreadSwitch = "_n5-a";
export var draftImage = "_n5-b";
export var draftImageContainer = "_n5-c";
export var draftImages = "_n5-e";
export var editButton = "_n5-g";
export var editor = "_n5-f";
export var editorContainer = "_n5-y";
export var editorErrorTooltipWrapper = "_n5-9";
export var headerDivider = "_n5-h";
export var icon = "_n5-i";
export var info = "_n5-j";
export var internal = "_n5-n";
export var internalDivider = "_n5-k";
export var internalMessage = "_n5-l";
export var messageInputCard = "_n5-m";
export var messageInputForm = "_n5-o";
export var messageInputFormInternal = "_n5-p";
export var options = "_n5-q";
export var publicMessageCustomer = "_n5-s";
export var publicMessageMerchant = "_n5-r";
export var removeImageButton = "_n5-d";
export var replyButtons = "_n5-t";
export var showSignatureButton = "_n5-u";
export var spinner = "_n5-v";
export var verticalButtonDivider = "_n5-4";
export var visibilitySelector = "_n5-w";
export var warning = "_n5-x";
export var wrappingText = "_n5-z";
export var writingInternalNoteTopBorder = "_n5-10";